import dayjs from "dayjs";
import cls from "classnames";
import { useEffect } from "react";
import func from "@uikit/func";
import { Modal, Button } from "antd";
import { useCreation } from "ahooks";
import { useSelector } from "react-redux";
import styles from "./PreviewMoreActions.module.scss";
import { PreviewMoreActionsBloc, PreviewMoreActionsBlocState } from "./PreviewMoreActionsBloc";
export interface updataType {
  appName: string;
  appDescription: string;
}
export interface PreviewMoreActionsProps {
  isModalOpen: boolean;
  confirmLoading: boolean;
  v2App: PreviewApp.PreviewAppV2FieldType | undefined;
  handleOk: (data: updataType) => void;
  handleCancel: () => void;
}

const CLOSE_ICON = "https://dopniceu5am9m.cloudfront.net/static/assets/230705/ACAEB5Cross.svg";

export function PreviewMoreActions(props: PreviewMoreActionsProps) {
  const selectedTemplate = useSelector((state: any) => state.studio.selectedTemplate);

  const state = new PreviewMoreActionsBlocState();
  const bloc = useCreation(() => new PreviewMoreActionsBloc(state), []);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      clickUpdata();
    }
  };

  function clickUpdata() {
    const data: updataType = {
      appName: bloc.state.appName.value,
      appDescription: bloc.state.appDescription.value,
    };
    props.handleOk(data);
  }

  const publishStr = () => {
    let str = "Never published";
    const publishedData = selectedTemplate?.published_metadata_v2?.find(
      (x: PreviewApp.PublishedMetadataV2Type) => x.id === props?.v2App?.id
    );

    if (publishedData?.published_at) {
      const time = dayjs(publishedData.published_at).format("MMM D, YYYY");
      str = `${time}`;
    }
    return str;
  };

  useEffect(() => {
    if (props.isModalOpen && !func.isEmpty(props.v2App)) {
      bloc.setInit(props.v2App);
    }
  }, [props.isModalOpen]);

  if (func.isEmpty(props.v2App) || !props.isModalOpen) return <div></div>;

  return (
    <div onKeyDown={key => handleKeyDown(key)}>
      <Modal
        title="Edit Publish View Detail"
        open={props.isModalOpen}
        centered
        onCancel={() => props.handleCancel()}
        wrapClassName={styles["previewMoreActionsModal"]}
        closeIcon={<img onClick={() => props.handleCancel()} src={CLOSE_ICON} width="20" height="20" alt="close" />}
        footer={[
          <Button
            loading={props.confirmLoading}
            type="primary"
            className={cls(styles["buttonBox"], styles["saveButton"])}
            key="submit"
            onClick={() => clickUpdata()}
          >
            Save
          </Button>,
          <div className={styles["buttonBox"]} key="back" onClick={() => props.handleCancel()}>
            Cancel
          </div>,
        ]}
      >
        <div className={styles["moreActionsModalContent"]}>
          <p>Project name</p>
          <input
            type="text"
            value={bloc.state.appName.value}
            className={styles["inputBox"]}
            onChange={e => bloc.onTitleChange(e)}
            placeholder="Add a name..."
          />
          <input
            type="text"
            value={bloc.state.appDescription.value}
            className={styles["inputBox"]}
            onChange={e => bloc.onPlaceholderChange(e)}
            placeholder="Add a description..."
          />
          <p>Last published: {publishStr()}</p>
        </div>
      </Modal>
    </div>
  );
}
